import './App.css';
import About from './components/About';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Home from './components/Home';
import NavBar from './components/NavBar';
import Services from './components/Services';
import { animateScroll } from 'react-scroll';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import Header from './components/Header';

const options = {
  duration: 500,
  smooth: true,
};

const scrollToTop = () => {
  animateScroll.scrollToTop(options);
};

function App() {
  return (
    <div className="overflow-x-hidden">
      {/* Fixed header sits outside the flow — always on top */}
      <Header />

      {/* Carousel is the very first visual, full-width */}
      <Carousel />

      {/* NavBar is absolute at the bottom of the carousel, then sticks to top on scroll */}
      <div className="relative">
        <NavBar />
        {/* Spacer so content below the carousel doesn't hide under a sticky nav */}
        <div className="h-[60px]" />
      </div>

      <Home />
      <About />
      <Services />
      <Contact />

      <div className="py-6">
        <div className="flex justify-center items-center cursor-pointer" onClick={scrollToTop}>
          <span className="uppercase text-primary text-xs mr-1">Scroll To Top</span>
          <IoArrowUpCircleOutline className="text-primary text-2xl" />
        </div>
      </div>
    </div>
  );
}

export default App;